import React, { useState } from 'react';
// ⚠️ CHART.JS IMPORTS
import Chart from "chart.js/auto";
import { Line, Bar, Doughnut } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';
//  REACT ICONS IMPORTS (You need to install 'react-icons/fa')
import {
    FaUsers, FaUser, FaClock, FaRoute,
    FaVenusMars, FaHospital, FaAmbulance, FaChartBar, FaTable,
    FaUserMd, FaWarehouse, FaPercent, FaBuilding, FaVial, FaPills, FaHeartbeat,
    FaHospitalSymbol, FaBed
} from 'react-icons/fa';
import Header from "components/Header";
// FIX: Assuming Header component is defined elsewhere or use a placeholder
// Header uses the darkest blue from the new palette
// const Header = ({ onMenuClick, dashboardName }) => (
//     <div className="bg-[#03045E] text-white p-4 shadow-md">
//         <h1 className="text-xl font-semibold">{dashboardName}</h1>
//     </div>
// );


// ====================================================================
// --- SURGERIES DATA ---
const surgeriesData = [
    { month: 'Jan', major: 320, minor: 680 },
    { month: 'Feb', major: 290, minor: 640 },
    { month: 'Mar', major: 350, minor: 720 },
    { month: 'Apr', major: 370, minor: 760 },
    { month: 'May', major: 410, minor: 810 },
    { month: 'Jun', major: 395, minor: 790 },
];

// --- INSURANCE DATA (PMJAY / Other) ---
const insuranceData = [
    { month: 'Jan', claimsRaised: 1200, claimsApproved: 980, amount: 4.5 },
    { month: 'Feb', claimsRaised: 1350, claimsApproved: 1100, amount: 5.1 },
    { month: 'Mar', claimsRaised: 1420, claimsApproved: 1180, amount: 5.6 },
    { month: 'Apr', claimsRaised: 1500, claimsApproved: 1250, amount: 6.2 },
    { month: 'May', claimsRaised: 1620, claimsApproved: 1380, amount: 6.8 },
    { month: 'Jun', claimsRaised: 1700, claimsApproved: 1450, amount: 7.1 },
];

// --- Dummy Data Definitions (Retained for functionality) ---
const dayWiseData = [
    { date: '01-12-2025', male: 55000, female: 65000, transgender: 50, total: 120050 },
    { date: '02-12-2025', male: 52000, female: 62000, transgender: 45, total: 114045 },
    { date: '03-12-2025', male: 48000, female: 59000, transgender: 60, total: 107060 },
    { date: '04-12-2025', male: 45000, female: 55000, transgender: 55, total: 100055 },
    { date: '05-12-2025', male: 44000, female: 53000, transgender: 40, total: 97040 },
    { date: '06-12-2025', male: 47000, female: 53000, transgender: 70, total: 100070 },
    { date: '07-12-2025', male: 500, female: 600, transgender: 5, total: 1105 },
    { date: '08-12-2025', male: 60000, female: 70000, transgender: 80, total: 130080 },
];

const shiftWiseData = [
    { date: "1 Dec", "Before 3PM (S1)": 120, "After 3PM (S2)": 80, "Other Shift": 30 },
    { date: "2 Dec", "Before 3PM (S1)": 140, "After 3PM (S2)": 95, "Other Shift": 25 },
    { date: "3 Dec", "Before 3PM (S1)": 130, "After 3PM (S2)": 85, "Other Shift": 20 },
    { date: "4 Dec", "Before 3PM (S1)": 150, "After 3PM (S2)": 100, "Other Shift": 35 },
    { date: "5 Dec", "Before 3PM (S1)": 160, "After 3PM (S2)": 110, "Other Shift": 28 },
    { date: "6 Dec", "Before 3PM (S1)": 170, "After 3PM (S2)": 105, "Other Shift": 22 },
    { date: "7 Dec", "Before 3PM (S1)": 155, "After 3PM (S2)": 98, "Other Shift": 26 },
    { date: "8 Dec", "Before 3PM (S1)": 165, "After 3PM (S2)": 115, "Other Shift": 33 },
];

const symptomsData = [
    { symptom: 'PAIN', cases: 58500 },
    { symptom: 'COUGH', cases: 46200 },
    { symptom: 'FEVER', cases: 37100 },
    { symptom: 'DOG BITE', cases: 29800 },
    { symptom: 'WEAKNESS', cases: 24500 },
    { symptom: 'WOUND', cases: 17300 },
    { symptom: 'ANC', cases: 15100 },
    { symptom: 'CHEST PAIN', cases: 7000 },
];

const diagnosisData = [
    { diagnosis: 'ATYPICAL FACIAL PAIN', count: 165 },
    { diagnosis: 'PARAPERTUSSIS WITH PNEUMONIA', count: 142 },
    { diagnosis: 'JE TO BORDETELLA PARAPERTUSSIS', count: 90 },
    { diagnosis: 'TYPHOID FEVER', count: 20 },
    { diagnosis: 'WHOOPING COUGH', count: 35 },
    { diagnosis: 'ACUTE NASOPHARYNGITIS (COMMON COLD)', count: 30 },
];

const departmentData = [
    { department: 'GENERAL PHYSICIAN', count: 580000 },
    { department: 'DENTAL', count: 35000 },
    { department: 'AYUSH', count: 28000 },
    { department: 'ORTHOPEDIC', count: 25000 },
    { department: 'PEDIATRIC', count: 20000 },
    { department: 'NEURO', count: 8000 },
    { department: 'PSYCHIATRIC', count: 7500 },
];

const ageData = [
    { age_group: '0-5 Years', patients: 15500 },
    { age_group: '6-18 Years', patients: 25000 },
    { age_group: '19-45 Years', patients: 65000 },
    { age_group: '46-65 Years', patients: 45000 },
    { age_group: '65+ Years', patients: 20000 },
];

const facilityStatusData = [
    { type: 'Operational DH', count: 12 },
    { type: 'Operational SDH', count: 35 },
    { type: 'Operational CHCs', count: 120 },
    { type: 'Operational PHCs', count: 850 },
    { type: 'Operational SCs', count: 4500 },
];

const hrAvailabilityData = [
    { cadre: 'Doctors', available: 850, sanctioned: 1000 },
    { cadre: 'Nurses', available: 3200, sanctioned: 3500 },
    { cadre: 'ANMs', available: 4800, sanctioned: 5000 },
    { cadre: 'CHOs', available: 2100, sanctioned: 2300 },
    { cadre: 'ASHA Workers', available: 2300, sanctioned: 2800 },
];

const ambulanceData = [
    { day: '01 Dec', available: 45, avg_response_time: 25 },
    { day: '02 Dec', available: 48, avg_response_time: 22 },
    { day: '03 Dec', available: 42, avg_response_time: 28 },
    { day: '04 Dec', available: 49, avg_response_time: 20 },
    { day: '05 Dec', available: 50, avg_response_time: 19 },
    { day: '06 Dec', available: 47, avg_response_time: 23 },
    { day: '07 Dec', available: 44, avg_response_time: 26 },
    { day: '08 Dec', available: 46, avg_response_time: 24 },
];

const ipdData = {
    totalWards: 12,
    totalBeds: 500,
    bedOccupancy: 0.78, // 78%
    bedsWithOxygen: 350,
    bedsWithVentilator: 40,
    bedsWithO2Vent: 390, // Combined for Stat Card
    availableBeds: 110, // Calculated
    avgPatientStay: 4.5, // Days
    internalTransfers: 125,
    referralExternal: 85,
    totalAdmissions: "43,742",
    wardWiseData: [
        { ward: 'General Medicine', beds: 150, occupancy: 0.85, discharge: 45 },
        { ward: 'Surgery', beds: 100, occupancy: 0.65, discharge: 30 },
        { ward: 'Pediatrics', beds: 80, occupancy: 0.90, discharge: 25 },
        { ward: 'Maternity', beds: 50, occupancy: 0.70, discharge: 15 },
        { ward: 'Emergency', beds: 120, occupancy: 0.95, discharge: 50 },
    ]
};

const stockOutData = [
    { month: 'Jan', drugs: 5, vaccines: 2 },
    { month: 'Feb', drugs: 4, vaccines: 1 },
    { month: 'Mar', drugs: 6, vaccines: 3 },
    { month: 'Apr', drugs: 3, vaccines: 1 },
    { month: 'May', drugs: 2, vaccines: 0 },
    { month: 'Jun', drugs: 7, vaccines: 4 },
    { month: 'Jul', drugs: 5, vaccines: 2 },
    { month: 'Aug', drugs: 4, vaccines: 1 },
    { month: 'Sep', drugs: 3, vaccines: 1 },
    { month: 'Oct', drugs: 3, vaccines: 0 },
    { month: 'Nov', drugs: 1, vaccines: 0 },
    { month: 'Dec', drugs: 4, vaccines: 0 },
];

const opdMetrics = {
    overallPatients: "7,72,545",
    scanAndShare: "2,50,123",
    revisitFollowup: "3,10,222",
    newPatientRegistration: "4,62,323",
    genderRatio: "1000:1167",
    averagePatientLoad: "250",
    journeyTime: "39 Min",
    waitingTime: "29 Min",
};

const labRadiologyData = {
    totalTests: 15500,
    categoryTests: [
        { category: 'Blood', count: 8000 },
        { category: 'Urine', count: 4500 },
        { category: 'Stool', count: 1500 },
        { category: 'Other', count: 1500 },
    ],
    recommendedVsConducted: { recommended: 16000, conducted: 15500 },
    avgProcessTime: 35, // Minutes
    radiologyScreenings: 4500,
    screeningCategory: [
        { category: 'X-Ray', count: 3000 },
        { category: 'Ultrasound', count: 1000 },
        { category: 'CT Scan', count: 500 },
    ],
    avgScreeningTime: 45, // Minutes
};

const supplyChainData = {
    procurementTime: 45, // Days
    frequentlyIndented: [
        { drug: 'Paracetamol', count: 500 },
        { drug: 'Amoxicillin', count: 350 },
        { drug: 'Salbutamol', count: 200 },
    ],
    expiredWashedValue: "₹ 5,75,000",
};

const ihipData = [
    { week: 'Wk 1', detection: 0.95, notification: 0.90, investigation: 0.85, response: 0.80 },
    { week: 'Wk 2', detection: 0.92, notification: 0.88, investigation: 0.82, response: 0.78 },
    { week: 'Wk 3', detection: 0.98, notification: 0.95, investigation: 0.90, response: 0.85 },
    { week: 'Wk 4', detection: 0.90, notification: 0.85, investigation: 0.78, response: 0.70 },
];
// -------------------------------------------------------------


// --- NEW PROFESSIONAL CHART COLOR DEFINITIONS (Based on Coolors Palette) ---
// Palette: 03045E, 023E8A, 0077B6, 0096C7, 00B4D8, 48CAE4, 90E0EF, ADE8F4, CAF0F8

const COLORS = {
    // Main Blues (Dark to Light/Mid)
    DEEP_NAVY: '#03045E',
    DARK_BLUE: '#023E8A',   // Used for solid bar fill
    MID_BLUE: '#0077B6',
    CYAN_BLUE: '#0096C7',   // Secondary Lines/Borders
    LIGHT_CYAN: '#00B4D8',
    BAR_LIGHT: '#90E0EF',   // Used for bar fill in combined charts (to ensure line visibility)

    // Non-Blue colors for contrast/risk
    RISK_RED: '#f49e4c',
    RISK_RED_T: 'rgba(185, 28, 28, 0.4)',
    HIGHLIGHT_PINK: '#FF66B3', // Retained for Female/Specific Accent
};

const CHART_COLORS = {
    // Mapped Colors for Chart Data (Lines and solid borders)
    total: COLORS.DEEP_NAVY,
    male: COLORS.MID_BLUE,
    female: COLORS.HIGHLIGHT_PINK,
    transgender: COLORS.LIGHT_CYAN,

    // Shift colors (darker shades for solid bars)
    s1: COLORS.MID_BLUE,
    s2: COLORS.CYAN_BLUE,
    other: COLORS.LIGHT_CYAN,

    // Bar chart fill colors (mostly solid, dark blue for visibility)
    primaryF: COLORS.DARK_BLUE,     // Solid dark blue fill
    secondaryF: COLORS.MID_BLUE,    // Solid mid blue fill
    riskF: COLORS.RISK_RED,         // Solid red fill

    // Combined chart fill colors (light fill, dark line)
    barLightF: COLORS.BAR_LIGHT,

    // Specific use colors
    available: COLORS.CYAN_BLUE,      // Blue for positive/available
    sanctioned: COLORS.MID_BLUE,      // Neutral for capacity
    ambulanceUnits: COLORS.BAR_LIGHT, // Light bar for units
    responseTime: COLORS.RISK_RED,    // Red line for response time

    // Doughnut/Pie chart colors
    labCategories: [COLORS.DEEP_NAVY, COLORS.CYAN_BLUE, COLORS.LIGHT_CYAN, COLORS.HIGHLIGHT_PINK],
    risk: COLORS.RISK_RED,
    other: COLORS.BAR_LIGHT, // for available portion in doughnut
};

// --- Chart Data Generators (Updated with New Colors and Solid/Combined Strategies) ---

const getDayWiseChartData = () => ({
    labels: dayWiseData.map(d => d.date),
    datasets: [
        { label: 'Total Patients', data: dayWiseData.map(d => d.total), borderColor: CHART_COLORS.total, backgroundColor: CHART_COLORS.total, borderWidth: 2, tension: 0.4 },
        { label: 'Female', data: dayWiseData.map(d => d.female), borderColor: CHART_COLORS.female, backgroundColor: CHART_COLORS.female, borderWidth: 2, tension: 0.4 },
        { label: 'Male', data: dayWiseData.map(d => d.male), borderColor: CHART_COLORS.male, backgroundColor: CHART_COLORS.male, borderWidth: 2, tension: 0.4 },
        { label: 'Transgender', data: dayWiseData.map(d => d.transgender), borderColor: CHART_COLORS.transgender, backgroundColor: CHART_COLORS.transgender, borderWidth: 1, borderDash: [5, 5], tension: 0.4 },
    ],
});

const getSymptomsChartData = () => ({
    labels: symptomsData.map(d => d.symptom),
    datasets: [{
        label: 'Total Cases',
        data: symptomsData.map(d => d.cases),
        // SOLID FILL
        backgroundColor: CHART_COLORS.riskF,
        borderColor: CHART_COLORS.riskF,
        borderWidth: 1.5,
    }],
});

const getShiftWiseChartData = () => ({
    labels: shiftWiseData.map(d => d.date),
    datasets: [
        // SOLID FILL
        { label: 'Before 3PM (S1)', data: shiftWiseData.map(d => d['Before 3PM (S1)']), backgroundColor: CHART_COLORS.s1, borderColor: CHART_COLORS.s1, borderWidth: 1.5, stack: 'Stack 0' },
        { label: 'After 3PM (S2)', data: shiftWiseData.map(d => d['After 3PM (S2)']), backgroundColor: CHART_COLORS.s2, borderColor: CHART_COLORS.s2, borderWidth: 1.5, stack: 'Stack 0' },
        { label: 'Other Shift', data: shiftWiseData.map(d => d['Other Shift']), backgroundColor: CHART_COLORS.other, borderColor: CHART_COLORS.other, borderWidth: 1.5, stack: 'Stack 0' },
    ],
});

const getDiagnosisChartData = () => ({
    labels: diagnosisData.map(d => d.diagnosis),
    datasets: [{
        label: 'Diagnosed Count',
        data: diagnosisData.map(d => d.count),
        // SOLID FILL
        backgroundColor: CHART_COLORS.primaryF,
        borderColor: CHART_COLORS.total,
        borderWidth: 1.5,
    }],
});

const getDepartmentChartData = () => ({
    labels: departmentData.map(d => d.department),
    datasets: [{
        label: 'Patient Count',
        data: departmentData.map(d => d.count),
        // SOLID FILL
        backgroundColor: CHART_COLORS.primaryF,
        borderColor: CHART_COLORS.total,
        borderWidth: 1.5,
    }],
});

const getAgeChartData = () => ({
    labels: ageData.map(d => d.age_group),
    datasets: [{
        label: 'Patients',
        data: ageData.map(d => d.patients),
        // SOLID FILL
        backgroundColor: CHART_COLORS.primaryF,
        borderColor: CHART_COLORS.total,
        borderWidth: 1.5,
    }],
});

const getFacilityStatusData = () => ({
    labels: facilityStatusData.map(d => d.type.replace('Operational ', '')),
    datasets: [{
        label: 'Operational Count',
        data: facilityStatusData.map(d => d.count),
        // SOLID FILL
        backgroundColor: CHART_COLORS.secondaryF,
        borderColor: CHART_COLORS.secondaryF,
        borderWidth: 1.5,
    }],
});

const getHRAvailabilityData = () => ({
    labels: hrAvailabilityData.map(d => d.cadre),
    datasets: [
        // SOLID FILL - Darker for Sanctioned (Capacity), Lighter for Available (Performance)
        { label: 'Available', data: hrAvailabilityData.map(d => d.available), backgroundColor: CHART_COLORS.available, borderColor: CHART_COLORS.available, borderWidth: 1.5 },
        { label: 'Sanctioned', data: hrAvailabilityData.map(d => d.sanctioned), backgroundColor: CHART_COLORS.sanctioned, borderColor: CHART_COLORS.sanctioned, borderWidth: 1.5 },
    ],
});

const getAmbulanceChartData = () => ({
    labels: ambulanceData.map(d => d.day),
    datasets: [
        // BAR: Use light color (BAR_LIGHT) so line is visible over it
        { type: 'bar', label: 'Available Units', data: ambulanceData.map(d => d.available), backgroundColor: CHART_COLORS.barLightF, borderColor: CHART_COLORS.barLightF, borderWidth: 1.5, yAxisID: 'y1' },
        // LINE: Use dark color (RISK_RED) for high visibility
        { type: 'line', label: 'Avg. Response Time (Min)', data: ambulanceData.map(d => d.avg_response_time), borderColor: CHART_COLORS.responseTime, backgroundColor: CHART_COLORS.responseTime, borderWidth: 2, fill: false, yAxisID: 'y2' },
    ],
});

const getStockOutData = () => ({
    labels: stockOutData.map(d => d.month),
    datasets: [
        { label: 'Essential Drugs (Days)', data: stockOutData.map(d => d.drugs), borderColor: COLORS.RISK_RED, backgroundColor: COLORS.RISK_RED, borderWidth: 2, tension: 0.4 },
        { label: 'Vaccines (Days)', data: stockOutData.map(d => d.vaccines), borderColor: COLORS.CYAN_BLUE, backgroundColor: COLORS.CYAN_BLUE, borderWidth: 2, tension: 0.4 },
    ],
});
const getSurgeriesChartData = () => ({
    labels: surgeriesData.map(d => d.month),
    datasets: [
        {
            label: 'Major Surgeries',
            data: surgeriesData.map(d => d.major),
            backgroundColor: COLORS.DARK_BLUE,
            stack: 'surgery'
        },
        {
            label: 'Minor Surgeries',
            data: surgeriesData.map(d => d.minor),
            backgroundColor: COLORS.LIGHT_CYAN,
            stack: 'surgery'
        }
    ]
});
const getInsuranceChartData = () => ({
    labels: insuranceData.map(d => d.month),
    datasets: [
        {
            type: 'bar',
            label: 'Claims Raised',
            data: insuranceData.map(d => d.claimsRaised),
            backgroundColor: COLORS.MID_BLUE,
            yAxisID: 'y1'
        },
        {
            type: 'bar',
            label: 'Claims Approved',
            data: insuranceData.map(d => d.claimsApproved),
            backgroundColor: COLORS.CYAN_BLUE,
            yAxisID: 'y1'
        },
        {
            type: 'line',
            label: 'Amount (₹ Cr)',
            data: insuranceData.map(d => d.amount),
            borderColor: COLORS.RISK_RED,
            borderWidth: 2,
            yAxisID: 'y2'
        }
    ]
});
const insuranceOptions = () => ({
    responsive: true,
    maintainAspectRatio: false, // ⭐ MOST IMPORTANT
    interaction: { mode: 'index', intersect: false },
    scales: {
        y1: {
            beginAtZero: true,
            position: 'left',
            title: { display: true, text: 'Number of Claims' }
        },
        y2: {
            beginAtZero: true,
            position: 'right',
            grid: { drawOnChartArea: false },
            title: { display: true, text: 'Amount (₹ Crore)' }
        }
    }
});

const getWardOccupancyData = () => ({
    labels: ipdData.wardWiseData.map(d => d.ward),
    datasets: [
        // BAR: Use light color (BAR_LIGHT) for occupancy %
        { label: 'Occupancy %', data: ipdData.wardWiseData.map(d => (d.occupancy * 100).toFixed(1)), backgroundColor: CHART_COLORS.barLightF, borderColor: CHART_COLORS.barLightF, borderWidth: 1.5, yAxisID: 'y1' },
        // LINE: Use dark color (DEEP_NAVY) for discharge count
        { label: 'Discharge Count', data: ipdData.wardWiseData.map(d => d.discharge), backgroundColor: CHART_COLORS.total, borderColor: CHART_COLORS.total, borderWidth: 2, yAxisID: 'y2' },
    ],
});

const getBedOccupancyDoughnutData = () => ({
    labels: ['Occupied', 'Available'],
    datasets: [{
        data: [ipdData.bedOccupancy, 1 - ipdData.bedOccupancy].map(p => (p * 100).toFixed(1)),
        backgroundColor: [CHART_COLORS.risk, CHART_COLORS.other],
        hoverBackgroundColor: [CHART_COLORS.risk, CHART_COLORS.other],
    }]
});

const getLabTestCategoryData = () => ({
    labels: labRadiologyData.categoryTests.map(d => d.category),
    datasets: [{
        label: 'Total Tests',
        data: labRadiologyData.categoryTests.map(d => d.count),
        backgroundColor: CHART_COLORS.labCategories,
    }],
});

const getIhipChartData = () => ({
    labels: ihipData.map(d => d.week),
    datasets: [
        { label: 'Detection Rate (%)', data: ihipData.map(d => (d.detection * 100).toFixed(1)), borderColor: COLORS.DEEP_NAVY, tension: 0.4 },
        { label: 'Notification Timeliness (%)', data: ihipData.map(d => (d.notification * 100).toFixed(1)), borderColor: COLORS.CYAN_BLUE, tension: 0.4 },
        { label: 'Investigation Rate (%)', data: ihipData.map(d => (d.investigation * 100).toFixed(1)), borderColor: COLORS.LIGHT_CYAN, tension: 0.4 },
        { label: 'Response Timeliness (%)', data: ihipData.map(d => (d.response * 100).toFixed(1)), borderColor: COLORS.RISK_RED, tension: 0.4 },
    ],
});

// --- Chart Options (Retained) ---
const commonOptions = (title) => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { position: 'top' },
        title: { display: false, text: title },
        datalabels: { display: false }
    },
    scales: {
        x: { ticks: { autoSkip: true, maxRotation: 45, minRotation: 45 } },
    }
});

const lineChartOptions = (title) => ({
    ...commonOptions(title),
    scales: {
        y: { beginAtZero: true, grid: { borderDash: [5, 5], color: COLORS.LIGHT_CYAN + '80' } },
        x: { grid: { display: false } }
    },
});

const barChartOptions = (title) => ({
    ...commonOptions(title),
    datasets: {
        bar: {
            borderRadius: 8,
            borderSkipped: 'bottom',
        }
    },
    scales: {
        y: { beginAtZero: true },
        x: { grid: { display: false } }
    }
});

const stackedBarOptions = (title) => ({
    ...barChartOptions(title),
    scales: {
        x: { stacked: true },
        y: { stacked: true }
    }
});

const doughnutOptions = (title) => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { position: 'right' },
        title: { display: false, text: title },
        datalabels: {
            formatter: (value, ctx) => {
                let sum = ctx.dataset.data.reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
                let percentage = (value / sum * 100).toFixed(1) + "%";
                return percentage;
            },
            color: '#fff',
        }
    }
});

const getAmbulanceOptions = (title) => ({
    ...commonOptions(title),
    interaction: { mode: 'index', intersect: false },
    scales: {
        x: { grid: { display: false } },
        y1: { type: 'linear', display: true, position: 'left', beginAtZero: true, title: { display: true, text: 'Available Units' } },
        y2: { type: 'linear', display: true, position: 'right', beginAtZero: true, grid: { drawOnChartArea: false }, title: { display: true, text: 'Avg. Response Time (Min)' } }
    }
});

const getIpdOccupancyOptions = (title) => ({
    ...commonOptions(title),
    interaction: { mode: 'index', intersect: false },
    scales: {
        x: { grid: { display: false } },
        y1: { type: 'linear', display: true, position: 'left', beginAtZero: true, max: 100, title: { display: true, text: 'Occupancy (%)' } },
        y2: { type: 'linear', display: true, position: 'right', beginAtZero: true, grid: { drawOnChartArea: false }, title: { display: true, text: 'Discharge Count' } }
    }
});

const ihipOptions = (title) => ({
    ...lineChartOptions(title),
    scales: {
        y: { beginAtZero: true, max: 100, title: { display: true, text: 'Percentage (%)' } }
    }
});
// ====================================================================
// --- Reusable Components (Retained) ---

const TabularView = ({ data, columns }) => (
    <div className="overflow-x-auto h-64">
        <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0">
                <tr>
                    {columns.map((col, index) => (
                        <th key={index} className="px-3 py-2 text-left text-xs font-medium text-gray-700 tracking-wider">
                            {col}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 text-sm">
                {data.map((row, rowIndex) => (
                    <tr key={rowIndex} className="hover:bg-blue-50/50">
                        {columns.map((col, colIndex) => {
                            const displayValue = row[col] || row[col.toLowerCase().replace(/ /g, '_')] || (typeof row === 'object' ? row[Object.keys(row).find(key => key.toLowerCase() === col.toLowerCase().replace(/\(.+\)/, '').trim())] : row);
                            return (
                                <td key={colIndex} className={`px-3 py-2 whitespace-nowrap ${colIndex === columns.length - 1 ? 'font-bold' : ''}`}>
                                    {displayValue}
                                </td>
                            );
                        })}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

const DateRangeLine = () => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

    const formatDate = (date) =>
        date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });

    return (
        <span className="text-sm text-slate-500 font-medium truncate px-3 py-1">State : <span className='font-bold text-slate-700'>Maharashtra</span> Date Range: <span className='font-bold text-slate-700'>{formatDate(firstDay)} to {formatDate(today)}</span></span>
    );
};


const Card = ({ title, children, fullWidth = false, viewState, setViewState, viewKey }) => {
    const widthClass = fullWidth ? 'col-span-1' : 'w-full';

    const handleToggle = (view) => {
        setViewState(prev => ({ ...prev, [viewKey]: view }));
    };

    return (
        <div className={`${widthClass} bg-white shadow-md rounded-lg p-4 transition-all duration-300 `}>
            <div className="flex justify-between items-start mb-3 border-b border-gray-100 pb-2">
                <h3 className="text-sm font-bold text-gray-700">{title}</h3>
                {setViewState && viewKey && (
                    <div className="inline-flex rounded-md shadow-sm" role="group">
                        <button
                            type="button"
                            onClick={() => handleToggle('Graph')}
                            // Use DEEP_NAVY for active button
                            className={`px-3 py-1 text-xs font-medium rounded-l-lg transition-colors duration-150 ease-in-out ${viewState[viewKey] === 'Graph' ? 'bg-[#03045E] text-white shadow-inner' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                        >
                            <FaChartBar className="inline mr-1" /> Graph
                        </button>
                        <button
                            type="button"
                            onClick={() => handleToggle('Tabular')}
                            // Use DEEP_NAVY for active button
                            className={`px-3 py-1 text-xs font-medium rounded-r-lg transition-colors duration-150 ease-in-out ${viewState[viewKey] === 'Tabular' ? 'bg-[#03045E] text-white shadow-inner' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                        >
                            <FaTable className="inline mr-1" /> Tabular
                        </button>
                    </div>
                )}
            </div>
            {children}
        </div>
    );
};


// --- StatCard (CONDENSED STYLING & NEW COLORS) ---
const StatCard = ({ label, value, subValue = null, Icon, colorClass }) => {
    return (
        // Reduced padding and margin
        <div className="bg-white shadow-sm rounded-md p-2 flex items-center mb-2 border border-gray-100">
            {/* Reduced icon size/padding */}
            <div className={`p-2 rounded-md ${colorClass} text-white mr-2 flex-shrink-0`}>
                {Icon && <Icon className="text-xl" />}
            </div>
            <div className="flex flex-col flex-grow text-right">
                {/* Reduced font size */}
                <p className="text-[10px] text-slate-500 font-medium truncate mb-0.5 leading-tight">{label}</p>
                <p className={`text-lg font-extrabold text-gray-800`}>{value}</p>
                {subValue && (
                    <p className={`text-[10px] text-gray-500 font-semibold mt-0.5`}>
                        [{subValue}]
                    </p>
                )}
            </div>
        </div>
    );
};

// --- Main Dashboard Component ---

const PatientStatistics = () => {
    const handleMenuClick = () => { /* Sidebar click */ };
    const [viewState, setViewState] = useState({
        dayInflow: 'Graph',
        symptoms: 'Graph',
        shiftInflow: 'Graph',
        diagnosis: 'Graph',
        department: 'Graph',
        age: 'Graph',
        facilityStatus: 'Graph',
        hrAvailability: 'Graph',
        ambulance: 'Graph',
        stockOut: 'Graph',
        wardOccupancy: 'Graph',
        labTests: 'Graph',
        ihip: 'Graph',
        opdDept: 'Graph',
        surgeries: 'Graph',
        insurance: 'Graph',
    });

    // Categorized Metrics Data for Condensed Sidebar
    const categorizedMetrics = [
        {
            metrics: [
                { label: "Procurement Time", value: `${supplyChainData.procurementTime} Days`, Icon: FaPills, colorClass: "bg-[#f49e4c]", key: "PT" },
                // Pink for Expired Value (distinct highlight)
                { label: "Expired/Washed Drugs Value", value: supplyChainData.expiredWashedValue, Icon: FaWarehouse, colorClass: "bg-[#FF66B3]", key: "EWV" },
                { label: "Avg Ambulance Response Time", value: "23 Min", Icon: FaAmbulance, colorClass: "bg-[#0096C7]", key: "ART" },
                // Mid Blue for coverage/surveillance
                { label: "Outbreak Detection Rate (Wk 4)", value: `${(ihipData[3].detection * 100).toFixed(1)}%`, Icon: FaRoute, colorClass: "bg-[#0096C7]", key: "ODR" },
            ]
        },
    ];
    const categorizedMetrics1 = [
        {
            metrics: [
                { label: "Patients Visited (OPD)", value: opdMetrics.overallPatients, Icon: FaUsers, colorClass: "bg-[#03045E]", key: "PV" },
            ]
        },
    ];

    return (

        // Use a light background for contrast with the deep blue
        <div className="min-h-screen bg-gray-50 p-0">
            <Header onMenuClick={handleMenuClick} dashboardName="Health System & Service Delivery Dashboard (State Level)" />


            <div className="flex px-4 pt-2 pb-4">
                {/* Left Panel (20% Width) - CONDENSED STATS AREA */}
                {/* <div className="w-1/5 pr-4">
                    <div className="sticky top-4 space-y-4">
                        {categorizedMetrics.map((group, index) => (
                            <div key={index} className="bg-white p-3 rounded-lg shadow-md ">
                                <h3 className="text-xs font-bold text-gray-700 mb-2 border-b pb-1">{group.title}</h3>
                                {group.metrics.map((stat) => (
                                    <StatCard
                                        key={stat.key}
                                        label={stat.label}
                                        value={stat.value}
                                        subValue={stat.subValue}
                                        Icon={stat.Icon}
                                        // Mapping the color codes to Tailwind classes (using arbitrary values for exact match)
                                        colorClass={stat.colorClass}
                                    />
                                ))}
                            </div>
                        ))}
                    </div>
                </div> */}

                {/* Right Panel (80% Width) - CHARTS AREA */}
                <div className="w-[100%]">
                    {/* <div className="grid grid-cols-2 gap-2"> */}

                    {/* A. SYSTEM CAPACITY & HR */}

                    <div className="col-span-2">
                        <h2 className="text-lg font-bold text-gray-700 mb-2">Health System Capacity & Human Resources</h2>
                    </div>
                    <div className="grid grid-cols-2 gap-2 pt-2">
                        {/* Facility functionality status (SOLID BAR CHART) */}
                        <Card title="Facility Functionality Status" fullWidth={true} viewState={viewState} setViewState={setViewState} viewKey="facilityStatus">
                            <div className="h-64">
                                {viewState.facilityStatus === 'Graph' ? (
                                    <Bar data={getFacilityStatusData()} options={barChartOptions("Facility Status")} />
                                ) : (
                                    <TabularView data={facilityStatusData} columns={['type', 'count']} />
                                )}
                            </div>
                        </Card>

                        {/* HR availability by cadre (SOLID BAR CHART) */}
                        <Card title="HR Availability (Available vs Sanctioned)" fullWidth={true} viewState={viewState} setViewState={setViewState} viewKey="hrAvailability">
                            <div className="h-64">
                                {viewState.hrAvailability === 'Graph' ? (
                                    <Bar data={getHRAvailabilityData()} options={barChartOptions("HR Availability")} />
                                ) : (
                                    <TabularView data={hrAvailabilityData} columns={['cadre', 'available', 'sanctioned']} />
                                )}
                            </div>
                        </Card>
                    </div>
                    {/* B. IN-PATIENT FLOW & UTILIZATION */}

                    <div className="col-span-2">
                        <h2 className="text-lg font-bold text-gray-700 my-2 pt-2">In-Patient Flow & Utilization (IPD)</h2>
                    </div>
                    <div className="grid grid-cols-7 gap-2 pt-2">
                        <StatCard label="IPD Admissions" value={ipdData.totalAdmissions} Icon={FaBuilding} colorClass="bg-[#023E8A]" />
                        <StatCard label="Total Wards" value={ipdData.totalWards} Icon={FaBuilding} colorClass="bg-[#023E8A]" />
                        <StatCard label="Total Beds" value={ipdData.totalBeds} Icon={FaHospital} colorClass="bg-[#023E8A]" />

                        <StatCard label="O2/Ventilator Beds" value={ipdData.bedsWithO2Vent} Icon={FaHeartbeat} colorClass="bg-[#0096C7]" subValue={`${(ipdData.bedsWithO2Vent / ipdData.totalBeds * 100).toFixed(0)}% Capacity`} />
                        <StatCard label="Avg Patient Stay" value={`${ipdData.avgPatientStay} Days`} Icon={FaClock} colorClass="bg-[#0096C7]" subValue="Goal: < 5 Days" />

                        <StatCard label="External Referrals" value={ipdData.referralExternal} Icon={FaRoute} colorClass="bg-[#f49e4c]" subValue="Count this Period" />
                        <StatCard label="Internal Transfers" value={ipdData.internalTransfers} Icon={FaUserMd} colorClass="bg-[#0096C7]" subValue="Patient movement" />
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 mt-2">
                        {/* Bed Occupancy Rate (Doughnut) */}
                        <Card title={`Bed Occupancy Rate - ${(ipdData.bedOccupancy * 100).toFixed(1)}%`} fullWidth={false} viewKey={null}>
                            <div className="flex justify-center items-center h-52">
                                <div className="w-2/3 h-full">
                                    <Doughnut data={getBedOccupancyDoughnutData()} options={doughnutOptions("Bed Occupancy")} />
                                </div>
                            </div>
                        </Card>

                        {/* ENHANCED IPD Key Metrics Card */}
                        {/* <Card title="IPD Key Metrics" fullWidth={false} viewKey={null}> */}

                        {/* </Card> */}

                        {/* Ward-wise Bed Occupancy & Discharge (COMBINED CHART) */}
                        <Card title="Ward-wise Bed Occupancy & Discharge" fullWidth={true} viewState={viewState} setViewState={setViewState} viewKey="wardOccupancy">
                            <div className="h-64">
                                {viewState.wardOccupancy === 'Graph' ? (
                                    <Bar data={getWardOccupancyData()} options={getIpdOccupancyOptions("Ward Occupancy")} />
                                ) : (
                                    <TabularView
                                        data={ipdData.wardWiseData.map(d => ({ ...d, occupancy: `${(d.occupancy * 100).toFixed(1)}%` }))}
                                        columns={['ward', 'beds', 'occupancy', 'discharge']}
                                    />
                                )}
                            </div>
                        </Card>
                    </div>
                    <div className="col-span-2">
                        <h2 className="text-lg font-bold text-gray-700 my-2 pt-2">
                            Surgeries & Insurance Utilization
                        </h2>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                        <Card
                            title="Monthly Surgical Procedures (Major vs Minor)"
                            fullWidth={true}
                            viewState={viewState}
                            setViewState={setViewState}
                            viewKey="surgeries"
                        >
                            <div className="h-64">
                                {viewState.surgeries === 'Graph' ? (
                                    <Bar
                                        data={getSurgeriesChartData()}
                                        options={stackedBarOptions("Surgeries")}
                                    />
                                ) : (
                                    <TabularView
                                        data={surgeriesData}
                                        columns={['Month', 'Major', 'Minor']}
                                    />
                                )}
                            </div>
                        </Card>
                        <Card
                            title="Insurance Claims & Amount (PMJAY / State Schemes)"
                            fullWidth={true}
                            viewState={viewState}
                            setViewState={setViewState}
                            viewKey="insurance"
                        >
                            <div className="h-64">
                                {viewState.insurance === 'Graph' ? (
                                    <Bar
                                        data={getInsuranceChartData()}
                                        options={insuranceOptions()}
                                    />
                                ) : (
                                    <TabularView
                                        data={insuranceData}
                                        columns={['Month', 'ClaimsRaised', 'ClaimsApproved', 'Amount']}
                                    />
                                )}
                            </div>
                        </Card>
                    </div>
                    <div className="col-span-2">
                        <h2 className="text-lg font-bold text-gray-700 my-2 pt-2">Emergency, Logistics & Supply Chain</h2>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-2 pt-2">
                        {categorizedMetrics.flatMap(group =>
                            group.metrics.map(stat => (
                                <StatCard
                                    key={stat.key}
                                    label={stat.label}
                                    value={stat.value}
                                    subValue={stat.subValue}
                                    Icon={stat.Icon}
                                    colorClass={stat.colorClass}
                                />
                            ))
                        )}
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 mt-2">
                        {/* Ambulance Availability & Response Time (COMBINED CHART) */}
                        <Card title="Ambulance Availability & Response Time" fullWidth={true} viewState={viewState} setViewState={setViewState} viewKey="ambulance">
                            <div className="h-64">
                                {viewState.ambulance === 'Graph' ? (
                                    <Bar data={getAmbulanceChartData()} options={getAmbulanceOptions("Ambulance Metrics")} />
                                ) : (
                                    <TabularView data={ambulanceData} columns={['day', 'available', 'avg_response_time']} />
                                )}
                            </div>
                        </Card>

                        {/* Stock-out days (essential drugs, vaccines) */}
                        <Card title="Stock-Out Days (Drugs & Vaccines)" fullWidth={true} viewState={viewState} setViewState={setViewState} viewKey="stockOut">
                            <div className="h-64">
                                {viewState.stockOut === 'Graph' ? (
                                    <Line data={getStockOutData()} options={lineChartOptions("Stock-Out Days")} />
                                ) : (
                                    <TabularView data={stockOutData} columns={['month', 'drugs', 'vaccines']} />
                                )}
                            </div>
                        </Card>

                        {/* Supply Chain: Procurement & Expired Drugs */}
                        <Card title="Supply Chain: Procurement & Frequently Indented" fullWidth={true} viewKey={null}>
                            <div className="h-64">
                                <TabularView data={supplyChainData.frequentlyIndented} columns={['drug', 'count']} />
                                {/* <div className="mt-4 border-t pt-3">
                                    <p className="font-semibold text-xs text-gray-700">Average Procurement Time: <span className="font-bold text-[#f49e4c]">{supplyChainData.procurementTime} Days</span></p>
                                    <p className="font-semibold text-xs text-gray-700">Expired/Washed Drugs Value: <span className="font-bold text-[#FF66B3]">{supplyChainData.expiredWashedValue}</span></p>
                                </div> */}
                            </div>
                        </Card>
                    </div>


                    <div className="col-span-2">
                        <h2 className="text-lg font-bold text-gray-700 my-2 pt-2">OPD & Diagnostics Flow</h2>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-2 pt-2">
                        {categorizedMetrics1.flatMap(group =>
                            group.metrics.map(stat => (
                                <StatCard
                                    key={stat.key}
                                    label={stat.label}
                                    value={stat.value}
                                    subValue={stat.subValue}
                                    Icon={stat.Icon}
                                    colorClass={stat.colorClass}
                                />
                            ))
                        )}
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 mt-2">
                        {/* LAB Total Tests & Category-wise Count (Doughnut) */}
                        <Card title={`LAB: Total Tests (${labRadiologyData.totalTests.toLocaleString('en-IN')})`} fullWidth={true} viewState={viewState} setViewState={setViewState} viewKey="labTests">
                            <div className="h-64">
                                {viewState.labTests === 'Graph' ? (
                                    <Doughnut data={getLabTestCategoryData()} options={doughnutOptions("Lab Test Categories")} />
                                ) : (
                                    <TabularView data={labRadiologyData.categoryTests} columns={['category', 'count']} />
                                )}
                            </div>
                        </Card>


                        {/* Patients by Symptoms (SOLID BAR CHART) */}
                        <Card title="Patients by Symptoms" fullWidth={true} viewState={viewState} setViewState={setViewState} viewKey="symptoms">
                            <div className="h-64">
                                {viewState.symptoms === 'Graph' ? (
                                    <Bar data={getSymptomsChartData()} options={barChartOptions("Patients by Symptoms")} />
                                ) : (
                                    <TabularView data={symptomsData} columns={['symptom', 'cases']} />
                                )}
                            </div>
                        </Card>

                        {/* --- EXISTING CHARTS (Moved to the end of the section) --- */}

                        {/* Day-Wise Inflow */}
                        <Card title="Day-Wise Inflow of Patients" fullWidth={true} viewState={viewState} setViewState={setViewState} viewKey="dayInflow">
                            <div className="h-64">
                                {viewState.dayInflow === 'Graph' ? (
                                    <Line data={getDayWiseChartData()} options={lineChartOptions("Day-Wise Inflow")} />
                                ) : (
                                    <TabularView data={dayWiseData} columns={['date', 'male', 'female', 'transgender', 'total']} />
                                )}
                            </div>
                        </Card>
                    </div>

                    {/* Radiology Screenings & Metrics */}

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 mt-2">
                        {/* Shift-Wise Inflow (SOLID STACKED BAR CHART) */}
                        <Card title="Shift-Wise Inflow of Patients" fullWidth={true} viewState={viewState} setViewState={setViewState} viewKey="shiftInflow">
                            <div className="h-64">
                                {viewState.shiftInflow === 'Graph' ? (
                                    <Bar data={getShiftWiseChartData()} options={stackedBarOptions("Shift-Wise Inflow")} />
                                ) : (
                                    <TabularView data={shiftWiseData} columns={['date', 'Before 3PM (S1)', 'After 3PM (S2)', 'Other Shift']} />
                                )}
                            </div>
                        </Card>

                        {/* Patients by Diagnosis (SOLID BAR CHART) */}
                        <Card title="Patients by Diagnosis" fullWidth={true} viewState={viewState} setViewState={setViewState} viewKey="diagnosis">
                            <div className="h-64">
                                {viewState.diagnosis === 'Graph' ? (
                                    <Bar data={getDiagnosisChartData()} options={barChartOptions("Patients by Diagnosis")} />
                                ) : (
                                    <TabularView data={diagnosisData} columns={['diagnosis', 'count']} />
                                )}
                            </div>
                        </Card>

                        {/* Patients by Department (Registration) (SOLID BAR CHART) */}
                        <Card title="Patients by Department (Registration)" fullWidth={true} viewState={viewState} setViewState={setViewState} viewKey="department">
                            <div className="h-64">
                                {viewState.department === 'Graph' ? (
                                    <Bar data={getDepartmentChartData()} options={barChartOptions("Patients by Department")} />
                                ) : (
                                    <TabularView data={departmentData} columns={['department', 'count']} />
                                )}
                            </div>
                        </Card>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 mt-2">
                        {/* Patients by Age (SOLID BAR CHART) */}
                        <Card title="Patients by Age Group" fullWidth={true} viewState={viewState} setViewState={setViewState} viewKey="age">
                            <div className="h-64">
                                {viewState.age === 'Graph' ? (
                                    <Bar data={getAgeChartData()} options={barChartOptions("Patients by Age")} />
                                ) : (
                                    <TabularView data={ageData} columns={['age_group', 'patients']} />
                                )}
                            </div>
                        </Card>
                        <Card title={`Radiology: Total Screenings (${labRadiologyData.radiologyScreenings})`} fullWidth={true} viewKey={null}>
                            <div className="h-100 ">
                                <h4 className="text-sm font-semibold mb-2 text-gray-600">Screening Counts by Category</h4>
                                <TabularView data={labRadiologyData.screeningCategory} columns={['category', 'count']} />
                                <div className="mt-0 border-t pt-3">
                                    <p className="font-semibold text-xs text-gray-700">Test Recommended vs Conducted (LAB): <span className="font-bold text-[#0096C7]">{labRadiologyData.recommendedVsConducted.conducted} / {labRadiologyData.recommendedVsConducted.recommended}</span></p>
                                    <p className="font-semibold text-xs text-gray-700">Avg LAB Process Time: <span className="font-bold text-[#0096C7]">{labRadiologyData.avgProcessTime} Min</span></p>
                                    <p className="font-semibold text-xs text-gray-700">Avg Radiology Process Time: <span className="font-bold text-[#0096C7]">{labRadiologyData.avgScreeningTime} Min</span></p>
                                </div>
                            </div>
                        </Card>
                        <div>
                            <div className="col-span-2">
                                <h2 className="text-lg font-bold text-gray-700 my-2 pt-2">Disease Surveillance (IHIP)</h2>
                            </div>

                            {/* IHIP Timeliness Indicators */}
                            <Card title="IHIP Timeliness Indicators (Rates)" fullWidth={true} viewState={viewState} setViewState={setViewState} viewKey="ihip">
                                <div className="h-64">
                                    {viewState.ihip === 'Graph' ? (
                                        <Line data={getIhipChartData()} options={ihipOptions("IHIP Indicators")} />
                                    ) : (
                                        <TabularView
                                            data={ihipData.map(d => ({
                                                week: d.week,
                                                detection: `${(d.detection * 100).toFixed(1)}%`,
                                                notification: `${(d.notification * 100).toFixed(1)}%`,
                                                investigation: `${(d.investigation * 100).toFixed(1)}%`,
                                                response: `${(d.response * 100).toFixed(1)}%`
                                            }))}
                                            columns={['week', 'detection', 'notification', 'investigation', 'response']}
                                        />
                                    )}
                                </div>
                            </Card>

                        </div>

                    </div>


                    {/* </div> */}
                </div>
            </div>
        </div>
    );
};

export default PatientStatistics;